// developed by Param Partap Singh
import React, { useState } from 'react'
import Nav from '../Utils/Nav'
import Footer from '../Utils/Footer'
import '../Css/Start.css'
import banner from '../Assets/background2.JPG'
import windowManaul from '../Assets/Manuals/EDUROAM SETUP GUIDE-Windows.pdf'
import androidManual from '../Assets/Manuals/EDUROAM SETUP GUIDE-Android.pdf'

export default function Eduroam() {

  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>

    <style>

{`

/* Hero */
.hero {
  text-align: center;
  padding: 40px 20px;
}

.hero h2 {
  font-size: 2.3em;
  margin: 0;
  color: #06396d;
  letter-spacing: 2px;
}

.themed-line {
  width: 100px;
  height: 4px;
  background: linear-gradient(to right, #004080, #0066cc);
  margin: 10px auto 0;
  border-radius: 2px;
}

/* Container (MAIN FIX HERE) */
.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 25px;

  display: flex;
  flex-direction: column;   /* 🔥 ensures vertical layout */
  gap: 20px;               /* spacing between cards */
}

/* Card */
.card {
  background: white;
  border-radius: 8px;
  padding: 25px;

  width: 100%;
  display: block;          /* 🔥 prevents inline/flex issues */

}

.card h3 {
  margin-bottom: 15px;
  color: #002147;
}

.card h4 {
  margin-top: 20px;
  margin-bottom: 10px;
  color: #004080;
  font-weight: bold;
  font-size: 1.2em;
}

.manual-link {
  color: #004080;
  text-decoration: none;
  font-weight: bold;
  transition: color 0.3s;
}

.manual-link:hover {
  color: #0066cc;
  text-decoration: underline;
}

.link-button {
  display: inline-block;
  padding: 8px 16px;
  background: #004080;
  color: white;
  border-radius: 4px;
  text-decoration: none;
  font-weight: bold;
  transition: background 0.3s;
}

.link-button:hover {
  background: #0066cc;
  text-decoration: none;
}

/* Table */
table {
  width: 100%;
  border-collapse: collapse;
}

td {
  border: 1px solid #ddd;
  padding: 10px;
}

/* Highlight */
.highlight {
  background: #eef3ff;
  padding: 15px;
  border-left: 5px solid #004080;
  margin-top: 10px;
}

/* Steps */
.step {
  background: #f0f4ff;
  padding: 10px;
  margin: 10px 0;
  border-left: 4px solid #004080;
}

.step ul {
  margin-left: 15px;   /* control left shift */
  padding-left: 15px;  /* keeps bullets aligned nicely */
}

/* Accordion Button */
.accordion {
  width: 100%;
  text-align: left;
  padding: 15px;
  font-size: 16px;
  border: none;
  cursor: pointer;
  background: #004080;
  color: white;
  margin-top: 10px;
  border-radius: 5px;
  transition: background 0.3s ease;
}

.accordion:hover {
  background: #003060;
}

/* Accordion Panel (IMPORTANT FIX) */
.panel {
  display: block;   /* 🔥 DO NOT use display:none in React */
  padding: 15px;
  background: #f9fbff;
  border: 1px solid #ddd;
  border-radius: 5px;
  margin-top: 5px;

  animation: fadeIn 0.3s ease;
}

/* Optional smooth animation */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`}

</style>
      <Nav />

      <div className="hero">
        <h2>EDUROAM</h2>
        <div className="themed-line"></div>
      </div>

      <div className="main-container">

<div className="container">
        {/* About */}
        <div className="card">
          <h3>About eduroam</h3>

          <p>
            IIT Ropar is a participant in eduroam, a secure, worldwide Wi-Fi roaming service for the international research and education community. In India, eduroam is facilitated by ERNET India.
          </p><br/>

          <p>
         With eduroam, students, faculty, and staff can securely access internet connectivity at participating institutions worldwide using the SSID <b>eduroam</b>, without the need for separate credentials at each location.
          </p><br/>

          <p>
           User authentication is performed through the institute’s authentication system using LDAP and RADIUS services. Visitors from other eduroam-enabled institutions can also connect using the credentials provided by their home organization.
          </p><br/>

          <p>
         Eduroam is currently available in over 100 countries, providing seamless and secure connectivity across thousands of academic and research institutions globally.
          </p>
        </div>

        {/* Device Setup */}
        <div className="card">
          <h3>Device Setup</h3>

          {/* Windows */}
          <button className="accordion" onClick={() => toggleAccordion(0)}>
            {openIndex === 0 ? "− Windows Setup" : "+ Windows Setup"}
          </button>

          {openIndex === 0 && (
            <div className="panel">

              <div className="step"><b>Step 1:</b> Open Network Settings<br />
                Go to <b>Control Panel → Network and Internet → Network and Sharing Center</b>
              </div>

              <div className="step"><b>Step 2:</b> Create a New Connection<br />
                Click <b>Set up a new connection or network</b><br />
                Select <b>Manually connect to a wireless network</b><br />
                Click <b>Next</b>
              </div>

              <div className="step"><b>Step 3:</b> Enter Wireless Details
                <ul>
                  <li><b>Network Name (SSID):</b> eduroam</li>
                  <li><b>Security Type:</b> WPA2-Enterprise</li>
                  <li><b>Encryption Type:</b> AES</li>
                </ul>
                Click <b>Next</b>
              </div>

              <div className="step"><b>Step 4:</b> Modify Connection Settings<br />
                Click <b>Change connection settings</b><br />
                Go to the <b>Security</b> tab and set:
                <ul>
                  <li><b>Security Type:</b> WPA2-Enterprise</li>
                  <li><b>Encryption:</b> AES</li>
                  <li><b>Authentication Method:</b> Microsoft EAP-TTLS</li>
                </ul>
              </div>

              <div className="step"><b>Step 5:</b> Configure Authentication<br />
                Click <b>Settings</b><br />
                Uncheck <b>Enable Identity Privacy</b><br />
                Select:
                <ul>
                  <li><b>Non-EAP Method:</b> Unencrypted Password (PAP)</li>
                </ul>
                Click <b>OK</b>
              </div>

              <div className="step"><b>Step 6:</b> Advanced Settings<br />
                Click <b>Advanced Settings</b><br />
                Go to <b>802.1X Settings</b><br />
                Enable <b>Specify authentication mode</b><br />
                Select <b>User Authentication</b><br />
                Click <b>OK</b>
              </div>

              <div className="step"><b>Step 7:</b> Connect to eduroam<br />
                Click Wi-Fi icon → Select <b>eduroam</b><br />
                Click <b>Connect</b><br />
                Enter your <b>username and password</b><br />
                Click <b>OK</b>
              </div>

              <div className="step"><b>Step 8:</b> Verify Connection<br />
                Ensure status shows <b>Connected, Secured</b>
              </div>

              <div className="highlight">
                ⚠ <b>Important:</b> Some Windows systems may not fully support EAP-TTLS manual configuration. Contact IT Services if connection fails.
              </div>

              <div className="highlight">
                 <b>Detailed User Manual: </b> <a className='manual-link' href={windowManaul} target="_blank" style={{color: '#004080', textDecoration: 'none', fontWeight: 'bold'}}>Click Here</a>
              </div>

            </div>
          )}

          {/* Android */}
          <button className="accordion" onClick={() => toggleAccordion(1)}>
            {openIndex === 1 ? "− Android Setup" : "+ Android Setup"}
          </button>

          {openIndex === 1 && (
            <div className="panel">
              <div className="step">1. Open Wi-Fi Settings</div>
              <div className="step">2. Tap <b>eduroam</b></div>

              <div className="step">
                3. Configure:
                <ul>
                  <li>EAP Method: TTLS</li>
                  <li>Phase 2 Authentication: PAP</li>
                  <li>Identity: ldapusername@iitrpr.ac.in</li>
                  <li>Password: LDAP password</li>
                  <li>CA Certificate: Use system default / Do not validate</li>
                </ul>
              </div>

              <div className="step">4. Tap <b>Connect</b></div>
              
              <div className="highlight">
                 <b>Detailed User Manual: </b>  <a className='manual-link' href={androidManual} target="_blank" style={{color: '#004080', textDecoration: 'none', fontWeight: 'bold'}}>Click Here</a>
              </div>
            </div>
          )}

{/* Android */}
          <button className="accordion" onClick={() => toggleAccordion(2)}>
            {openIndex === 2 ? "− Login Credentials" : "+ Login Credentials"}
          </button>

          {openIndex === 2 && (
            <div className="panel">
              <div className="step">1. Username
                  <ul>
                  <li>Your UserID (LDAP) for Eduroam is the same as your institute email ID (before @).</li>
                  <li>For example, if your personal email ID is example@iitrpr.ac.in, then your Eduroam username will be example.</li>
                
                </ul>
              </div>
              <div className="step">2. Password : You can reset your login password using a Self-Service Portal by following the below steps:
                <ul>
                  <li>Open https://cas.iitrpr.ac.in and click on ‘Forgot Password’.</li>
                  <li>Enter your UserID (LDAP) as LDAP Username.</li>
                  <li>IIT Ropar email-ID and Captcha.</li>
                  <li>Click on "Send" button and check your inbox.</li>
                  <li>You will receive an email confirmation with a link to reset your password.</li>
                  <li>Using this link, reset the password which will be used to login for Eduroam.</li>
                
                </ul>
              </div>

        

           
            </div>
          )}


        </div>
        

        {/* Troubleshooting */}
        <div className="card">

          <h3>Troubleshooting</h3>
          <ul>
            <li>Ensure username format includes @iitrpr.ac.in</li>
            <li>Verify LDAP password</li>
            <li>Forget network and reconnect</li>
            <li>Restart device</li>
            <li>Contact IT Services if issue persists</li>
          </ul>
        </div>

      </div>
</div>
      <Footer />
    </>
  )
}